/**
 * SD-8.3: the save-failure split (UX-DR17, C.5's last two rows).
 *
 * "You do not have permission" and "the request failed" are DIFFERENT PROBLEMS with different
 * next actions, and the 20260803 guard trigger raises SQLSTATE 42501 precisely so they are
 * distinguishable: PostgREST maps it to HTTP 403 and passes the trigger's MESSAGE and HINT
 * through. The rule here is therefore: a 42501 is surfaced VERBATIM — the trigger's message
 * names the columns and its hint names who to ask, and replacing either with our own wording
 * would throw away the one part of the error that was written for the user. Everything else is
 * a retryable failure and says so, without leaking an object dump into a toast.
 */

export interface SaveErrorOutcome {
  kind: 'forbidden' | 'retryable';
  message: string;
}

interface PostgrestErrorish {
  code?: unknown;
  message?: unknown;
  hint?: unknown;
}

export function saveErrorMessage(error: unknown): SaveErrorOutcome {
  const e = (error ?? {}) as PostgrestErrorish;
  const code = typeof e.code === 'string' ? e.code : null;

  if (code === '42501') {
    const message = typeof e.message === 'string' ? e.message : 'You do not have permission to change this.';
    const hint = typeof e.hint === 'string' && e.hint.trim() ? e.hint.trim() : null;
    return { kind: 'forbidden', message: hint ? `${message} ${hint}` : message };
  }

  return {
    kind: 'retryable',
    message: 'Design settings could not be saved. Check your connection and try again.',
  };
}
